/**
 * Represents / manages the area overlay user interface
 * @constructor
 */
define(['c21/track', 'jquery'], function (track, $) {
   "use strict";

   return function () {
      var self = this,
         m_fnOnClick,
         m_selectedOverlay,
         m_jOverlays = $("#areaOverlaysDiv .areaOverlay"),

         initialize = function () {
            m_jOverlays.click(function () {
               var jOverlay = $(this),
                  bSelected = jOverlay.hasClass('selected');

               if (bSelected) {
                  m_selectedOverlay = jOverlay.attr('metaType');
                  track.doEvent('Hybrid Mapping', 'Heat Map Overlay Tool', 'Deselect ' + m_selectedOverlay);
                  jOverlay.removeClass('selected');
                  m_selectedOverlay = null;
               } else {
                  m_jOverlays.removeClass('selected');
                  jOverlay.addClass('selected');
                  m_selectedOverlay = jOverlay.attr('metaType');
                  track.doEvent('Hybrid Mapping', 'Heat Map Overlay Tool', 'Select ' + m_selectedOverlay);
               }

               if (m_fnOnClick) {
                  m_fnOnClick();
               }
            });
         };

      initialize();

      /**
       * Set an event to be triggered when the an option is changed
       * @param {Function} fnOnClick
       */
      self.setClickEvent = function (fnOnClick) {
         m_fnOnClick = fnOnClick;
      };

      /**
       * Get the currently selected overlay meta (if one is selected)
       * @return {String} Ex: "medianIncome"
       */
      self.getAreaOverlaySelection = function () {
         return m_selectedOverlay;
      };
   };
});
